import { useEffect, useState } from 'react';

/** Recording clock and small name helpers of the room (Beratung 10–15). */

/** 1458 → „24:18"; from one hour on „1:04:18". */
export function formatClock(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const rest = seconds % 60;
  const mm = String(minutes).padStart(2, '0');
  const ss = String(rest).padStart(2, '0');
  return hours > 0 ? `${hours}:${mm}:${ss}` : `${mm}:${ss}`;
}

/** Seconds since `startIso` at `now` (0 before the start or without a start). */
export function secondsSince(startIso: string | null, now: number): number {
  if (!startIso) return 0;
  return Math.max(0, Math.floor((now - Date.parse(startIso)) / 1000));
}

/** The current time, refreshed every `intervalMs` while mounted. */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);
  return now;
}

/** „Stefan Brunnthaler" → „S. Brunnthaler" (the call header and thumbnails of Beratung 11/12). */
export function shortPersonName(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length < 2) return name.trim();
  return `${parts[0]?.charAt(0) ?? ''}. ${parts.slice(1).join(' ')}`;
}

/** „Stefan Brunnthaler" → „SB". */
export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.charAt(0) ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.charAt(0) ?? '') : '';
  return `${first}${last}`.toUpperCase();
}
